import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import Image from 'next/image'
import MapIcon from 'public/icons/map-lg.svg'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { GoogleMapSection } from './OwnerInformation/parts/GoogleMapSection'

export const AccessTab: FC<{ owner: Owner }> = ({ owner }) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()
  const { default_address } = owner
  const { state, city } = default_address || {}

  if (!default_address?.address) {
    return (
      <div
        style={{
          paddingTop: 100,
          paddingBottom: 100,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 24,
          justifyContent: 'center',
        }}
      >
        <Image src="/no-objects/address.png" width={124} height={124} />
        <Typography.Text style={{ fontSize: 16, lineHeight: 1 }}>
          {t('公開住所はありません')}
        </Typography.Text>
      </div>
    )
  }

  return (
    <LocationBox
      style={{ display: 'flex', flexDirection: xs ? 'column' : 'row' }}
      xs={Boolean(xs)}
    >
      <div
        style={{ display: 'flex', flex: 1, flexDirection: 'column', gap: 16 }}
      >
        <Typography.Title
          style={{ color: 'var(--ax-gray-5, #656565)', fontWeight: 400 }}
        >
          {city}, {state}
        </Typography.Title>
        <IconTextBox>
          <MapIcon width={24} height={24} fill="#232427" />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {default_address.postal_code && (
              <Typography.Text>
                {`〒${default_address.postal_code.substring(
                  0,
                  3,
                )}-${default_address.postal_code.substring(3, 7)}`}
              </Typography.Text>
            )}
            <div>
              <Typography.Text>
                {default_address.state} {default_address.city}{' '}
                {default_address.address1}
              </Typography.Text>
              <Typography.Text>{default_address.address2}</Typography.Text>
            </div>
          </div>
        </IconTextBox>
      </div>
      <div style={{ width: '100%', flex: 1 }}>
        <GoogleMapSection address={default_address.address || ''} />
      </div>
    </LocationBox>
  )
}

const LocationBox = styled.div<{ xs: boolean }>`
  display: flex;
  padding: ${(props) => (props.xs ? '32px 16px 0px' : '60px 64px 0px')};
  align-items: flex-start;
  gap: ${(props) => (props.xs ? '16px' : '32px')};
  align-self: stretch;
`

const IconTextBox = styled.div`
  font-family: 'NotoSansJP';
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`
